


















































import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { TaskPriority, TaskPriorityLabels } from 'admiral-core';
import { CheckIcon, XIcon } from 'vue-feather-icons';
import TaskPriorityIcon from './TaskPriorityIcon.vue';

@Component({
  name: 'TaskPriorityFilter',
  components: {
    TaskPriorityIcon,
    CheckIcon,
    XIcon,
  },
})
export default class TaskPriorityFilter extends Vue {
  @Prop({ type: Array, default: () => [] })
  priorityFilter!: TaskPriority[];

  TaskPriority = TaskPriority;
  hovered = false;

  get priorityOptions(): { value: TaskPriority; label: string }[] {
    return [
      { value: TaskPriority.URGENT, label: TaskPriorityLabels[TaskPriority.URGENT] },
      { value: TaskPriority.HIGH, label: TaskPriorityLabels[TaskPriority.HIGH] },
      { value: TaskPriority.MEDIUM, label: TaskPriorityLabels[TaskPriority.MEDIUM] },
      { value: TaskPriority.LOW, label: TaskPriorityLabels[TaskPriority.LOW] },
      { value: TaskPriority.NO_PRIORITY, label: TaskPriorityLabels[TaskPriority.NO_PRIORITY] },
    ];
  }

  get displayPriorityForIcon(): TaskPriority {
    return this.priorityFilter[0] ?? TaskPriority.NO_PRIORITY;
  }

  get displayLabel(): string {
    if (this.priorityFilter.length === 0) return 'Alle Prioritäten';
    if (this.priorityFilter.length === 1) return TaskPriorityLabels[this.priorityFilter[0]];
    return `${TaskPriorityLabels[this.priorityFilter[0]]} + ${this.priorityFilter.length - 1}`;
  }

  isSelected(value: TaskPriority): boolean {
    return this.priorityFilter.includes(value);
  }

  togglePriority(value: TaskPriority) {
    const isSelected = this.isSelected(value);
    const newPriorities = isSelected
      ? this.priorityFilter.filter((p) => p !== value)
      : [...this.priorityFilter, value];
    this.$emit('update:priorityFilter', newPriorities);
  }

  clearFilter() {
    this.$emit('update:priorityFilter', []);
  }
}
